import * as React from "react"
import CustomHead from "../components/head"
import logo from "../images/logo.svg"

const IndexPage = () => (
<div class="h-screen text-center">
  <div class="size-full flex flex-col content-center gap-4 place-content-center">
    <span class="w-full flex justify-center">
      <img class="w-96" src={logo}></img>
    </span>
    <p>We're working on something new right now,<br /> stay tuned!</p>
    <p>In the meantime, feel free to say <a href="mailto:hello@netbrid.ge">Hello</a>!</p>
  </div>
</div>
)

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <CustomHead title="Home" />

export default IndexPage
